import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::start
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:40
* @route '/portal/impersonation/start'
*/
export const start = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(options),
    method: 'post',
})

start.definition = {
    methods: ["post"],
    url: '/portal/impersonation/start',
} satisfies RouteDefinition<["post"]>

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::start
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:40
* @route '/portal/impersonation/start'
*/
start.url = (options?: RouteQueryOptions) => {
    return start.definition.url + queryParams(options)
}

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::start
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:40
* @route '/portal/impersonation/start'
*/
start.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(options),
    method: 'post',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::start
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:40
* @route '/portal/impersonation/start'
*/
const startForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: start.url(options),
    method: 'post',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::start
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:40
* @route '/portal/impersonation/start'
*/
startForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: start.url(options),
    method: 'post',
})

start.form = startForm

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::stop
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:134
* @route '/portal/impersonation/stop'
*/
export const stop = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stop.url(options),
    method: 'post',
})

stop.definition = {
    methods: ["post"],
    url: '/portal/impersonation/stop',
} satisfies RouteDefinition<["post"]>

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::stop
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:134
* @route '/portal/impersonation/stop'
*/
stop.url = (options?: RouteQueryOptions) => {
    return stop.definition.url + queryParams(options)
}

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::stop
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:134
* @route '/portal/impersonation/stop'
*/
stop.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stop.url(options),
    method: 'post',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::stop
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:134
* @route '/portal/impersonation/stop'
*/
const stopForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: stop.url(options),
    method: 'post',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::stop
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:134
* @route '/portal/impersonation/stop'
*/
stopForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: stop.url(options),
    method: 'post',
})

stop.form = stopForm

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/portal/impersonation/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::status
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:181
* @route '/portal/impersonation/status'
*/
statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

status.form = statusForm

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
export const users = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: users.url(options),
    method: 'get',
})

users.definition = {
    methods: ["get","head"],
    url: '/portal/impersonation/users',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
users.url = (options?: RouteQueryOptions) => {
    return users.definition.url + queryParams(options)
}

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
users.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: users.url(options),
    method: 'get',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
users.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: users.url(options),
    method: 'head',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
const usersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: users.url(options),
    method: 'get',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
usersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: users.url(options),
    method: 'get',
})

/**
* @see \Core\Auth\Impersonation\Http\Controllers\ImpersonationController::users
* @see src/Core/Auth/Impersonation/Http/Controllers/ImpersonationController.php:194
* @route '/portal/impersonation/users'
*/
usersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: users.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

users.form = usersForm

const impersonation = {
    start: Object.assign(start, start),
    stop: Object.assign(stop, stop),
    status: Object.assign(status, status),
    users: Object.assign(users, users),
}

export default impersonation